import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router';

const app = createApp(App);

app.use(createPinia()); // Use the Pinia store
app.use(router); // Use the router instance

app.mount('#app');
